import Card from "./card.js";
export default class ImageOnly extends Card {
  constructor(s, t, i, h, l, r, e, n, o, u, a, c, d) {
    super(s, t, null, i, null, h, l, r, null, e, n, o, u, a, c, d),
      (this.ae = "ab-image-only"),
      (this.oe = !1),
      (this.test = !1);
  }
  bt() {
    const s = {};
    return (
      (s[Card.hs.ss] = Card.rs.Ii),
      (s[Card.hs.os] = this.id),
      (s[Card.hs.cs] = this.viewed),
      (s[Card.hs.ds] = this.imageUrl),
      (s[Card.hs.us] = this.updated),
      (s[Card.hs.ls] = this.expiresAt),
      (s[Card.hs.URL] = this.url),
      (s[Card.hs.xs] = this.aspectRatio),
      (s[Card.hs.bs] = this.extras),
      (s[Card.hs.gs] = this.pinned),
      (s[Card.hs.js] = this.dismissible),
      (s[Card.hs.zs] = this.clicked),
      (s[Card.hs.ks] = this.language),
      (s[Card.hs.qs] = this.altImageText),
      (s[Card.hs.vs] = this.test),
      s
    );
  }
}
